const acceptCookieBanner = (props) => {
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    gtag("consent", "default", {
      ad_storage: "denied",
      analytics_storage: "denied",
    });

    // Disable scroll and show banner only if no consent stored
    const consentStatus = localStorage.getItem("cookieConsent");
    //console.log("====consentStatus======", consentStatus);
    if (document?.getElementById("cookie-banner")) {
      if (!consentStatus) {
        document.getElementById("cookie-banner").style.display = "flex";
      } else {
        document.getElementById("cookie-banner").style.display = "none";
      }
    }
  }

  function gtag() {
    dataLayer.push(arguments);
  }

  // Accept Function: Full Consent + GA4 Event
  function acceptCookies() {
    gtag("consent", "update", {
      ad_user_data: "granted",
      ad_personalization: "granted",
      ad_storage: "granted",
      analytics_storage: "granted",
    });

    gtag("event", "cookie_consent", {
      consent_status: "accepted",
    });

    saveConsent("accepted");
  }

  // Deny Function: Block all + GA4 Event
  function denyCookies() {
    gtag("consent", "update", {
      ad_user_data: "denied",
      ad_personalization: "denied",
      ad_storage: "denied",
      analytics_storage: "denied",
    });

    gtag("event", "cookie_consent", {
      consent_status: "denied",
    });

    saveConsent("denied");
  }

  // Save choice & unlock scroll
  function saveConsent(status) {
    localStorage.setItem("cookieConsent", status);
    document.getElementById("cookie-banner").style.display = "none";
  }

  return (
    <div
      id="cookie-banner"
      className={`${props.style.cookie_banner} ${props.style.cookie_banner_hide}`}
    >
      <div className={props.style.cookie_wrap_banner}>
        <span className={props.style.cookie_banner__message}>
          We use cookies to enhance your experience.
        </span>
        <div className={props.style.download_btn}>
          <button
            onClick={acceptCookies}
            className={`${props.style.cookie_banner__button} ${props.style.cookie_banner__button__accept}`}
          >
            Accept Cookies
          </button>
          <button
            onClick={denyCookies}
            className={`${props.style.cookie_banner__button} ${props.style.cookie_banner__button__deny}`}
          >
            Deny Cookies
          </button>
        </div>
      </div>
    </div>
  );
};

export default acceptCookieBanner;
